<template>
  <base-dialog width="830px" :dialogVisible="dialogVisible" @handleOpen="handleOpen" @handleClose="handleClose" @handleConfirm="handleConfirm" @handleClosed="handleClosed">
    <template #title>{{$t('assignTaskV2.distribution')}}</template>
    <div class="assign-homework">
      <div class="header">
        <el-button type="primary" size="small" @click="handleCreateClass">{{$t('managementV2.createClass')}}</el-button>
      </div>
      <div class="class-table">
        <el-table height="100%" border :data="classList" header-row-class-name="customHeader" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="55" :resizable="false"></el-table-column>
          <el-table-column align="center" :label="$t('managementV2.number')" type="index" width="60" :resizable="false"></el-table-column>
          <el-table-column align="center" :label="$t('managementV2.className')" :resizable="false" prop="name"></el-table-column>
          <el-table-column align="center" :label="$t('managementV2.major')" :resizable="false" prop="major"></el-table-column>
          <el-table-column align="center" :label="$t('managementV2.member')" :resizable="false" prop="peopleNum"></el-table-column>
          <el-table-column align="center" :label="$t('managementV2.numberOfJobsCompleted')" :resizable="false">
            <template slot-scope="{ row }">{{row.finishTaskNum || 0}}</template>
          </el-table-column>
          <el-table-column align="center" :label="$t('managementV2.average')" :resizable="false">
            <template slot-scope="{ row }">{{row.averageScore || 0}}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/delDialog';

import { queryClass, assignJobToTheClass } from "@/services/jobManagement";

export default {
  name: 'AssignHomework',
  components: {
    BaseDialog,
  },
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    globalObj: {
      type: Object,
      require: true,
    },
  },
  data () {
    return {
      classList: [],
      multipleSelection: [],

      // 切换团队不影响使用的companyCode
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose');
    },
    async handleConfirm () {
      if (this.multipleSelection.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('homeworkManage.checkClass'));
        return;
      }
      let { success } = await assignJobToTheClass({
        classIdList: this.multipleSelection.map(i => i.id),
        fileId: this.globalObj.id,
        companyCode: this.companyCode,
      });
      if (success) {
        this.$message.closeAll();
        this.$message.success(this.$t('jobManagementV2.AssignSuccess'));
        this.handleClose();
        this.$emit('update');
      }
    },
    handleClosed () {
      this.classList = [];
      this.multipleSelection = [];
    },
    async getClassList () {
      let { success, result } = await queryClass({
        companyCode: this.companyCode,
      });
      if (success) {
        // 去掉班级人数为0的
        this.classList = result.filter(item => item.peopleNum !== 0);
      }
    },
    handleOpen () {
      this.getClassList();
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    handleCreateClass () {
     this.$emit('addClass')
    },
  },
}
</script>

<style lang="less" scoped>
.assign-homework {
  text-align: left;
}
.class-table {
  margin-top: 15px;
  height: 270px;
  /deep/.el-table__body-wrapper .cell {
    color: #666;
  }
  /deep/.customHeader {
    th {
      background: #F3F7FE;
      color: #566087;
      font-weight: bold;
    }
  }
  /deep/.el-table-column--selection {
    .cell {
      padding: 0 10px;
    }
  }
}
</style>